import { CompanyOffersGuard } from './components/company-offers/company-offers.guard';
import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { AppSettings } from './app.settings';
import { AdManagerComponent } from './components/admanager/admanager.component';
import { AdminActionsComponent } from './components/admin-actions/admin-actions.component';
import { AdvertisingAdsComponent } from './components/advertising-ads/advertising-ads.component';
import { AdvertisingAdvertisersComponent } from './components/advertising-advertisers/advertising-advertisers.component';
import { AdvertisingCampaignsComponent } from './components/advertising-campaigns/advertising-campaigns.component';
import { AdvertisingCreativesComponent } from './components/advertising-creatives/advertising-creatives.component';
import { AdvertisingFlightsComponent } from './components/advertising-flights/advertising-flights.component';
import { AdvertisingImpressionsComponent } from './components/advertising-impressions/advertising-impressions.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { BillingComponent } from './components/billing/billing.component';
import { AgencyComponent } from './components/brokeragency/agency/agency.component';
import { BrokerComponent } from './components/brokeragency/broker/broker.component';
import { ClientsComponent } from './components/brokeragency/clients/clients.component';
import { MemberEnrollComponent } from './components/brokeragency/member-enroll/member-enroll.component';
import { ProductDetailsComponent } from './components/brokeragency/product-details/product-details.component';
import { ProvisioningComponent } from './components/brokeragency/provisioning/provisioning.component';
import { VendorGroupsComponent } from './components/brokeragency/vendor-groups/vendor-groups.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { BrandsPageComponent } from './components/contentadmin/brands-page/brands-page.component';
import { VendorProductsPageComponent } from './components/contentadmin/vendor-products-page/vendor-products-page.component';
import { VendorsPageComponent } from './components/contentadmin/vendors-page/vendors-page.component';
import { ManagesupportagentsComponent } from './components/customersupport/managesupportagents/managesupportagents.component';
import { ManageusersComponent } from './components/customersupport/manageusers/manageusers.component';
import { ReportsComponent } from './components/customersupport/reports/reports.component';
import { EmailCodeComponent } from './components/email-code/email-code.component';
import { EnvSyncComponent } from './components/env-sync/env-sync.component';
import { Convert834Component } from './components/convert-834';
import { BrokeradminComponent } from './components/externalbrokeradmin/brokeradmin.component';
import { HomeComponent } from './components/home/home.component';
import { InsuranceBrokersComponent } from './components/insurance-brokers/insurance-brokers.component';
import { InsuranceCarriersComponent } from './components/insurance-carriers/insurance-carriers.component';
import { InsuranceEmployersComponent } from './components/insurance-employers/insurance-employers.component';
import { InsuranceUsersComponent } from './components/insurance-users/insurance-users.component';
import { InsuranceProfileComponent } from './components/insuranceprofile/insuranceprofile.component';
import { IntegrationHomeComponent } from './components/integrationhome/integrationhome.component';
import { InvitationsComponent } from './components/invitations/invitations.component';
import { LoginComponent } from './components/login/login.component';
import { ManageMembersComponent } from './components/managemembers/managemembers.component';
import { ManageWellspaceComponent } from './components/managewellspace/managewellspace.component';
import { MyTeamComponent } from './components/my-team/my-team.component';
import { TeamManagerWorkspaceGuard } from './guards/team-manager-workspace/team-manager-workspace.guard';
import { MarketingCampaignsComponent } from './components/marketing-campaigns/marketing-campaigns.component';
import { MediaContentComponent } from './components/media-content/media-content.component';
import { MediaDocumentsComponent } from './components/media-documents/media-documents.component';
import { MediaImagesComponent } from './components/media-images/media-images.component';
import { ProfileComponent } from './components/profile/edit-profile.page';
import { PurchasesComponent } from './components/purchases/purchases.component';
import { ReconciliationComponent } from './components/reconciliation/reconciliation.component';
import { SettingsAndPermissionsComponent } from './components/settingsandpermissions/settingsandpermissions.component';
import { TeamCompaniesComponent } from './components/team-companies/team-companies.component';
import { TeampaymentsComponent } from './components/teampayments/teampayments.component';
import { TokenComponent } from './components/token/token.page';
import { VendorProductDetailsComponent } from './components/vendor-products/tabs/vendor-products-product-list/details/vendor-product-details/vendor-product-details.component';
import { VendorProductsComponent } from './components/vendor-products/vendor-products.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { CanDeactivateGuard } from './guards/can-deactivate/can-deactivate.guard';
import { ClientFeatureGuard } from './guards/client-feature/client-feature.guard';
import { EmbeddedGuard } from './guards/embedded/embedded.guard';
import { ManagerAdminGuard } from './guards/manageradmin/manageradmin.guard';
import { SuperadminGuard } from './guards/superadmin/superadmin.guard';
import { ExactSuperadminGuard } from './guards/exact-superadmin/exact-superadmin.guard';
import { PayrollHomeRedirectGuard } from './guards/payroll-home-redirect/payroll-home-redirect.guard';
import { PayrollAccessGuard } from './guards/payroll-access/payroll-access.guard';
import { PayrollWorkspaceGuard } from './guards/payroll-workspace/payroll-workspace.guard';
import { PayrollExpenseApprovalsGuard } from './guards/payroll-expense-approvals/payroll-expense-approvals.guard';
import { WellspaceContextGuard } from './guards/wellspace-context/wellspace-context.guard';
import { ClientBenefitsAccessGuard } from './guards/client-benefits-access/client-benefits-access.guard';
import { PayrollProductsComponent } from './components/payrolladmin/payroll-products/payroll-products.component';
import { PayrollDeductionsComponent } from './components/payrolladmin/payroll-deductions/payroll-deductions.component';
import { PayrollDashboardsComponent } from './components/payrolladmin/payroll-dashboards/payroll-dashboards.component';
import { PayrollReportsComponent } from './components/payrolladmin/payroll-reports/payroll-reports.component';
import { PayrollVendorComponent } from './components/payrolladmin/payroll-vendors/payroll-vendors.component';
import { AdminFeesPageComponent } from './components/contentadmin/admin-fees-page/admin-fees-page.component';
import { PayrollTeamsComponent } from './components/payrolladmin/payroll-teams/payroll-teams.component';
import { PayrollExpenseApprovalsComponent } from './components/payrolladmin/payroll-expense-approvals/payroll-expense-approvals.component';
import { SuperadminUsersComponent } from './components/superadmin/users/superadmin-users.component';
import { SuperadminUsersDwollaComponent } from './components/superadmin/users/details/superadmin-users-dwolla.component';
import { SuperadminRewardsComponent } from './components/superadmin/rewards/superadmin-rewards.component';
import { SuperadminRewardDetailComponent } from './components/superadmin/rewards/details/superadmin-reward-detail.component';
import { SuperadminBrandDetailComponent } from './components/superadmin/rewards/details/superadmin-brand-detail.component';
import { SuperadminCampaignDetailComponent } from './components/superadmin/rewards/details/superadmin-campaign-detail.component';
import { SuperadminClaimedDetailComponent } from './components/superadmin/rewards/details/superadmin-claimed-detail.component';
import { SuperadminRebateDetailComponent } from './components/superadmin/rewards/details/superadmin-rebate-detail.component';
import { CobrandingListComponent } from './components/superadmin/cobranding/cobranding-list.component';
import { BrandDomainsComponent } from './components/superadmin/brand-domains/brand-domains.component';
import { JsonConfigComponent } from './components/superadmin/json-config/json-config.component';
import { ManagedFeatureFlagsComponent } from './components/superadmin/managed-feature-flags/managed-feature-flags.component';
import { ManagedFeatureFlagsListComponent } from './components/superadmin/managed-feature-flags-list/managed-feature-flags-list.component';
import { ManagedFeatureFlagsComparisonComponent } from './components/superadmin/managed-feature-flags-comparison/managed-feature-flags-comparison.component';
import { AiAssistantComponent } from './components/superadmin/ai-assistant/ai-assistant.component';
import { InboundFileFeedsComponent } from './components/superadmin/inbound-file-feeds/inbound-file-feeds.component';
import { SensitiveDataAccessComponent } from './components/superadmin/sensitive-data-access/sensitive-data-access.component';
import { ProductClickEventsComponent } from './components/superadmin/product-click-events/product-click-events.component';
import { ObservabilityComponent } from './components/observability/observability.component';
import { FinanceContractsComponent } from './components/financeadmin/contracts/finance-contracts.component';
import { FinanceFundsMovementsComponent } from './components/financeadmin/funds-movements/finance-funds-movements.component';
import { FinanceInvoicesComponent } from './components/financeadmin/invoices/finance-invoices.component';
import { FinanceLedgerComponent } from './components/financeadmin/ledger/finance-ledger.component';
import { FinanceReportsComponent } from './components/financeadmin/reports/finance-reports.component';
import { FinanceSettlementsComponent } from './components/financeadmin/settlements/finance-settlements.component';
import { BankReconciliationComponent } from './components/financeadmin/bank-reconciliation/bank-reconciliation.component';
import { TransactionReconciliationGuard } from './guards/transaction-reconciliation/transaction-reconciliation.guard';
import { FinanceConnectionsComponent } from './components/financeadmin/connections/finance-connections.component';
import { SuperadminClaimedRewardComponent } from './components/superadmin/rewards/details/superadmin-claimed-reward.component';
import { SuperadminImportRewardsComponent } from './components/superadmin/rewards/details/superadmin-import-rewards.component';
import { SuperadminExportRewardsComponent } from './components/superadmin/rewards/details/superadmin-export-rewards.component';
import { PayrollCompanyComponent } from './components/payrolladmin/payroll-company/payroll-company.component';

const withOptionalId = (path: string, component: any): Route[] => [
  { path, component },
  { path: `${path}/:id`, component },
];

const homeRoute: Route = AppSettings.isPayrollAdmin()
  ? {
      path: '',
      component: HomeComponent,
      canActivate: [AuthGuard, PayrollAccessGuard, PayrollHomeRedirectGuard],
    }
  : {
      path: '',
      component: AppSettings.isIntegration() ? IntegrationHomeComponent : HomeComponent,
      canActivate: [AuthGuard],
    };

export const routes: Routes = [
  { path: 'offers', canActivate: [AuthGuard, CompanyOffersGuard], runGuardsAndResolvers: 'paramsOrQueryParamsChange', loadComponent: () => import('./components/company-offers/company-offers.component').then(m => m.CompanyOffersComponent) },
  homeRoute,

  {
    path: '2fa',
    loadChildren: () =>
      import('./components/two-factor-authentication/two-factor-authentication.module').then(
        (m) => m.TwoFactorAuthenticationModule,
      ),
  },

  { path: 'admanager', component: AdManagerComponent, canActivate: [AuthGuard] },

  {
    path: 'admin/actions',
    component: AdminActionsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'advertising',
    canActivate: [AuthGuard],
    children: [
      { path: 'ads', component: AdvertisingAdsComponent },
      { path: 'advertisers', component: AdvertisingAdvertisersComponent },
      { path: 'campaigns', component: AdvertisingCampaignsComponent },
      { path: 'creatives', component: AdvertisingCreativesComponent },
      { path: 'flights', component: AdvertisingFlightsComponent },
      { path: 'impressions', component: AdvertisingImpressionsComponent },
    ],
  },

  {
    path: 'analytics',
    canActivate: [AuthGuard, WellspaceContextGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'overview' },
      { path: 'agency-members', component: AnalyticsComponent },
      { path: 'allowance-allocation-report', component: AnalyticsComponent },
      { path: 'allowances', component: AnalyticsComponent },
      { path: 'allocation-report', component: AnalyticsComponent },
      { path: 'approve/:userId', component: AnalyticsComponent },
      { path: 'categories', component: AnalyticsComponent },
      { path: 'overview', component: AnalyticsComponent },
      { path: 'payment-report', component: AnalyticsComponent },
      { path: 'peer-to-peer', component: AnalyticsComponent },
      { path: 'reimbursements', component: AnalyticsComponent },
      { path: 'reimbursements/:userId', component: AnalyticsComponent },
      { path: 'rewards-report', component: AnalyticsComponent },
      { path: 'spending-report', component: AnalyticsComponent },
      { path: 'team-allowances', component: AnalyticsComponent },
      { path: 'team-overview', component: AnalyticsComponent },
    ],
  },

  {
    path: 'billing',
    canActivate: [AuthGuard, WellspaceContextGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'stripepaymentmethods' },
      { path: 'stripeavailablepaymentmethods', component: BillingComponent },
      { path: 'stripechargehistory', component: BillingComponent },
      { path: 'stripecreditcard', component: BillingComponent },
      { path: 'stripepaymentmethods', component: BillingComponent },
    ],
  },

  {
    path: 'billingreturn/:teamId',
    component: AppSettings.isIntegration() ? IntegrationHomeComponent : HomeComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'brokeragency',
    canActivate: [AuthGuard],
    children: [
      { path: 'agency', redirectTo: 'agency/agency-clients', pathMatch: 'full' },

      ...withOptionalId('agency/agency-profile', AgencyComponent),
      ...withOptionalId('agency/agency-clients', AgencyComponent),
      ...withOptionalId('agency/agency-members', AgencyComponent),
      ...withOptionalId('agency/agency-producers', AgencyComponent),

      { path: 'broker', redirectTo: 'broker/broker-agencies', pathMatch: 'full' },
      ...withOptionalId('broker/broker-profile', BrokerComponent),
      ...withOptionalId('broker/broker-agencies', BrokerComponent),
      ...withOptionalId('broker/broker-products', BrokerComponent),

      { path: 'clients', component: ClientsComponent, canActivate: [ClientBenefitsAccessGuard] },
      ...withOptionalId('clients/client-census', ClientsComponent).map(route => ({
        ...route,
        canActivate: [ClientBenefitsAccessGuard],
      })),
      ...withOptionalId('clients/client-eligibility', ClientsComponent).map(route => ({
        ...route,
        canActivate: [ClientBenefitsAccessGuard],
      })),
      ...withOptionalId('clients/client-enrollment', ClientsComponent).map(route => ({
        ...route,
        canActivate: [ClientBenefitsAccessGuard],
        data: {allowClient: false},
      })),

      { path: 'member/enroll', component: MemberEnrollComponent },
      { path: 'product/details/:productId', component: ProductDetailsComponent },
    ],
  },

  {
    path: 'categories',
    component: CategoriesComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'clients',
    loadChildren: () => import('./components/clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [AuthGuard, ClientFeatureGuard],
  },

  {
    path: 'contentadmin',
    canActivate: [AuthGuard],
    children: [
      { path: 'adminFees', component: AdminFeesPageComponent },
      { path: 'brands', component: BrandsPageComponent },
      { path: 'vendors', component: VendorsPageComponent },
      {
        path: 'vendorproducts',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'vendor-pending-transfers' },
          { path: 'vendor-completed-transfers', component: VendorProductsPageComponent },
          { path: 'vendor-pending-transfers', component: VendorProductsPageComponent },
        ],
      },
    ],
  },

  {
    path: 'customersupport',
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'managecustomers' },
      { path: 'managecustomers', component: ManageusersComponent },
      { path: 'managesupportagents', component: ManagesupportagentsComponent },
      { path: 'reports', component: ReportsComponent },
    ],
  },

  { path: 'emailcode/:email', component: EmailCodeComponent, canActivate: [AuthGuard] },

  { path: 'env-sync', component: EnvSyncComponent, canActivate: [SuperadminGuard] },
  { path: 'convert-834', component: Convert834Component, canActivate: [SuperadminGuard] },

  { path: 'externalbrokeradmin', component: BrokeradminComponent, canActivate: [SuperadminGuard] },

  {
    path: 'insurance',
    canActivate: [AuthGuard],
    children: [
      { path: 'brokers', component: InsuranceBrokersComponent },
      { path: 'carriers', component: InsuranceCarriersComponent },
      { path: 'employers', component: InsuranceEmployersComponent },
      { path: 'users', component: InsuranceUsersComponent },
    ],
  },

  { path: 'insuranceprofile', component: InsuranceProfileComponent, canActivate: [AuthGuard] },
  {
    path: 'insuranceprofile/embedded/:userId',
    component: InsuranceProfileComponent,
    canActivate: [EmbeddedGuard],
  },

  { path: 'invitations', component: InvitationsComponent, canActivate: [AuthGuard] },

  { path: 'login', component: LoginComponent },
  { path: 'login/:showTimeout', component: LoginComponent },

  {
    path: 'my-team',
    component: MyTeamComponent,
    canActivate: [AuthGuard, TeamManagerWorkspaceGuard],
  },
  {
    path: 'managewellspace',
    canActivate: [AuthGuard],
    children: [
      { path: 'agency-members/:teamId', component: ManageWellspaceComponent },
      {
        path: 'categories/:teamId',
        component: ManageWellspaceComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'overview/:teamId', component: ManageWellspaceComponent },
      { path: 'plan/:teamId', component: ManageWellspaceComponent },
      { path: 'products/:teamId', component: ManageWellspaceComponent },
      { path: 'program/:teamId', component: ManageWellspaceComponent },
    ],
  },

  {
    path: 'marketing-campaigns',
    canActivate: [SuperadminGuard],
    children: [
      { path: '', component: MarketingCampaignsComponent },
      { path: 'groups', component: MarketingCampaignsComponent },
      { path: 'history', component: MarketingCampaignsComponent },
      { path: 'list', component: MarketingCampaignsComponent },
      { path: 'sequences', component: MarketingCampaignsComponent },
    ],
  },

  {
    path: 'media',
    canActivate: [AuthGuard],
    children: [
      { path: 'content', component: MediaContentComponent },
      { path: 'documents', component: MediaDocumentsComponent },
      { path: 'images', component: MediaImagesComponent },
    ],
  },

  { path: 'managemembers', component: ManageMembersComponent, canActivate: [AuthGuard] },
  { path: 'dashboards', component: PayrollDashboardsComponent, canActivate: [AuthGuard] },

  {
    path: 'payrolladmin',
    canActivate: [AuthGuard, PayrollAccessGuard, PayrollWorkspaceGuard],
    canActivateChild: [PayrollWorkspaceGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'company/company' },
      { path: 'connections', pathMatch: 'full', redirectTo: 'company/company' },
      { path: 'company', pathMatch: 'full', redirectTo: 'company/company' },
      { path: 'company/:tab', component: PayrollCompanyComponent },
      { path: 'products', pathMatch: 'full', redirectTo: 'benefits' },
      { path: 'benefits', component: PayrollProductsComponent },
      { path: 'deductions', component: PayrollDeductionsComponent },
      { path: 'dashboards', component: PayrollDashboardsComponent },
      { path: 'reports', component: PayrollReportsComponent, canActivate: [SuperadminGuard] },
      { path: 'payrollvendors', component: PayrollVendorComponent, canActivate: [SuperadminGuard] },
      { path: 'teams', component: PayrollTeamsComponent },
      { path: 'expense-approvals', component: PayrollExpenseApprovalsComponent, canActivate: [PayrollExpenseApprovalsGuard] },
    ],
  },

  {
    path: 'products',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'companies' },
      { path: 'companies', component: TeamCompaniesComponent, canActivate: [ManagerAdminGuard] },
      { path: 'permissions', component: TeamCompaniesComponent, canActivate: [ManagerAdminGuard] },
      { path: 'subscriptions', component: TeamCompaniesComponent, canActivate: [SuperadminGuard] },
    ],
  },

  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'purchases',
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'transactions' },
      { path: 'approved', component: PurchasesComponent },
      { path: 'awaitingapproval', component: PurchasesComponent },
      { path: 'configure', component: PurchasesComponent },
      { path: 'denied', component: PurchasesComponent },
      { path: 'reimbursed', component: PurchasesComponent },
      { path: 'transactions', component: PurchasesComponent },
    ],
  },

  {
    path: 'reconciliation',
    canActivate: [SuperadminGuard],
    canActivateChild: [TransactionReconciliationGuard],
    children: [
      { path: 'apilog/:customerId', component: ReconciliationComponent },
      { path: 'stripe/:customerId', component: ReconciliationComponent },
      { path: 'teamlog/:customerId', component: ReconciliationComponent },
    ],
  },

  {
    path: 'settingsandpermissions',
    component: SettingsAndPermissionsComponent,
    canActivate: [AuthGuard],
  },

  { path: 'signup', pathMatch: 'full', redirectTo: 'login' },

  { path: 'teampayments', component: TeampaymentsComponent, canActivate: [SuperadminGuard] },

  {
    path: 'superadmin',
    canActivate: [SuperadminGuard],
    children: [
      {
        path: 'users',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'detail' },
          { path: 'detail', component: SuperadminUsersComponent },
          { path: 'subscription-dunning', component: SuperadminUsersComponent },
          { path: 'push', component: SuperadminUsersComponent },
          { path: 'blacklist', component: SuperadminUsersComponent },
          { path: 'dwolla/:userId', component: SuperadminUsersDwollaComponent },
        ],
      },
      {
        path: 'rewards',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'rewards' },
          { path: 'rewards', component: SuperadminRewardsComponent },
          { path: 'rebates', component: SuperadminRewardsComponent },
          { path: 'brands', component: SuperadminRewardsComponent },
          { path: 'campaigns', component: SuperadminRewardsComponent },
          { path: 'claimed', component: SuperadminRewardsComponent },
          { path: 'reward/new', component: SuperadminRewardDetailComponent },
          { path: 'reward/:id', component: SuperadminRewardDetailComponent },
          { path: 'brand/new', component: SuperadminBrandDetailComponent },
          { path: 'brand/:id', component: SuperadminBrandDetailComponent },
          { path: 'campaign/new', component: SuperadminCampaignDetailComponent },
          { path: 'campaign/:id', component: SuperadminCampaignDetailComponent },
          { path: 'claimed/new', component: SuperadminClaimedDetailComponent },
          { path: 'claimed/:id', component: SuperadminClaimedDetailComponent },
          { path: 'rebate/new', component: SuperadminRebateDetailComponent },
          { path: 'rebate/:id', component: SuperadminRebateDetailComponent },
          { path: 'claimed-reward/:rewardId', component: SuperadminClaimedRewardComponent },
          { path: 'import', component: SuperadminImportRewardsComponent },
          { path: 'export', component: SuperadminExportRewardsComponent },
        ],
      },
      { path: 'cobranding', component: CobrandingListComponent },
      { path: 'ai-assistant', component: AiAssistantComponent },
      { path: 'brand-domains', component: BrandDomainsComponent },
      { path: 'inbound-file-feeds', component: InboundFileFeedsComponent },
      { path: 'product-click-events', component: ProductClickEventsComponent },
      { path: 'sensitive-data-access', component: SensitiveDataAccessComponent },
      {
        path: 'managed-feature-flags/new',
        component: ManagedFeatureFlagsComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'managed-feature-flags/compare', component: ManagedFeatureFlagsComparisonComponent },
      {
        path: 'managed-feature-flags/:id',
        component: ManagedFeatureFlagsComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'managed-feature-flags', component: ManagedFeatureFlagsListComponent },
      { path: 'observability', component: ObservabilityComponent, canActivate: [ExactSuperadminGuard] },
      { path: 'json-config', component: JsonConfigComponent },
    ],
  },

  { path: 'token/:token/:refresh', component: TokenComponent },
  { path: 'token/:token/:refresh/:create', component: TokenComponent },
  { path: 'handoff', component: TokenComponent },

  {
    path: 'finance',
    canActivate: [SuperadminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'contracts' },
      { path: 'contracts', component: FinanceContractsComponent },
      { path: 'funds-movements', component: FinanceFundsMovementsComponent },
      { path: 'settlements', component: FinanceSettlementsComponent },
      { path: 'invoices', component: FinanceInvoicesComponent },
      { path: 'reports', component: FinanceReportsComponent },
      { path: 'ledger', component: FinanceLedgerComponent },
      { path: 'bank-reconciliation', component: BankReconciliationComponent },
      { path: 'bank-reconciliation/:importId', component: BankReconciliationComponent },
      { path: 'connections', component: FinanceConnectionsComponent, canActivate: [ExactSuperadminGuard] },
    ],
  },

  {
    path: 'vendor-products',
    canActivate: [SuperadminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'stripe-products' },
      { path: 'stripe-products', component: VendorProductsComponent },
      { path: 'vendor-products', component: VendorProductsComponent },
      { path: 'user-vendor-products', component: VendorProductsComponent },
      { path: 'vendor-webhooks', component: VendorProductsComponent },
      { path: 'vendor-api-log', component: VendorProductsComponent },
      { path: 'vendor-pending-transfers', component: VendorProductsComponent },
      { path: 'vendor-completed-transfers', component: VendorProductsComponent },
      { path: 'products/:productId', component: VendorProductDetailsComponent },
    ],
  },

  {
    path: 'vendorgroups',
    canActivate: [SuperadminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'products' },
      { path: 'plans', component: VendorGroupsComponent },
      { path: 'products', component: VendorGroupsComponent },
      { path: 'questions', component: VendorGroupsComponent },
      { path: 'rates', component: VendorGroupsComponent },
    ],
  },

  {
    path: 'workflows',
    loadChildren: () =>
      import('./components/workflows/workflows.module').then((m) => m.WorkflowsModule),
    canActivate: [AuthGuard],
  },

  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
